import api from "./client";

export async function trackVisit(path) {
  try {
    await api.post("/api/analytics/track", { path });
  } catch {
    // tracking failures are silent
  }
}

export async function getSummary(range = "daily") {
  const { data } = await api.get(`/api/analytics/summary?range=${range}`);
  return data;
}

export async function getTopPages() {
  const { data } = await api.get("/api/analytics/top-pages");
  // returns array of { path, visits }
  return Array.isArray(data) ? data : [];
}

export async function getDevices() {
  const { data } = await api.get("/api/analytics/devices");
  // returns { byDevice: [], byBrowser: [], byOs: [] }
  return data;
}

export async function getCountries() {
  const { data } = await api.get("/api/analytics/countries");
  // returns array of { country, visits }
  return Array.isArray(data) ? data : [];
}

export async function getTopReferrers() {
  const { data } = await api.get("/api/analytics/top-referrers");
  return Array.isArray(data) ? data : [];
}

export async function resetAnalytics() {
  const { data } = await api.delete("/api/analytics/reset");
  return data;
}
